import axios from "axios"
import {FETCH_POST_ORDER,FETCH_ERROR, FETCH_LOADING, FETCH_CART} from '../types/types'
import { toastr } from "react-redux-toastr"



export const FetchOrder = (delivery,TotalPrice,shipping) => async (dispatch,getState)=>{

    const orderItems = JSON.parse(localStorage.getItem("cartItems"));
    const data = {
       orderItems,delivery,TotalPrice:TotalPrice,shippingPrice:shipping,user:getState().user.User._id  
    }

    if(!localStorage.getItem("token")){
        dispatch({
            type:FETCH_ERROR
        })
        toastr.error("Login please")
    }else{
        dispatch({type:FETCH_LOADING})
        axios.post("https://shoppi-test.herokuapp.com/api/post/order",data,{
            headers:{
                "authorization": "bearer "+localStorage.getItem("token")
            }
        })
        .then(result =>{
            localStorage.removeItem("cartItems")
            dispatch({
                type:FETCH_POST_ORDER,
                payload:data
            })
            dispatch({
                type:FETCH_CART
            })
            toastr.success("Order Made with Success")
        })
        .catch(err =>{
            dispatch({
                type:FETCH_ERROR
            })
        })
    }

}